const translations = {
  "en": {
    "FAQ": "FAQ"
  },
  "zh-tw": {
    "FAQ": "常見問題"
  }
};

export default translations;
